import { Box, Skeleton } from '@mantine/core'

import classes from './GivingActionCard.module.scss'

export function GivingActionCardSkeleton() {
  return (
    <Box className={classes.Card} data-testid="giving-action-card-skeleton">
      <Skeleton height={26} width="40%" />
      <Box className={classes.Content}>
        <Skeleton height={20} width="55%" />
        <Skeleton height={22} width="80%" />
        <Skeleton height={20} />
        <Skeleton height={20} width="70%" />
      </Box>
      <Skeleton height={32} width="45%" />
    </Box>
  )
}
